import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class PasswordInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    disabled: PropTypes.func,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    inputTitle: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    maxCharacters: PropTypes.number
  }

  render() {
    const {action, name, title, inputTitle, label, value, disabled} = this.props;
    return (
      <div className="form-group">
        {label &&
          <label>{label}</label>
        }
        <input className="form-control"
          name={name}
          title={inputTitle}
          disabled={disabled}
          onChange={action}
          placeholder={title}
          type="password"
          value={value}/>
      </div>
    );
  }
}
